import React, { FC } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { InputBase } from '@mui/material'

export const InputBaseWrapper: FC<FieldRenderProps<any>> = ({
    input: { name, onChange, value, ...restInput },
    meta,
    inputProps,
    className,
    classes,
    ...rest
}): JSX.Element => {
    const showError = !meta.active && meta.error && meta.touched
    const combinedInputProps = { ...restInput, ...inputProps }
    return (
        <InputBase
            value={value}
            {...rest}
            name={name}
            className={className}
            classes={classes}
            error={showError}
            inputProps={combinedInputProps}
            onChange={onChange}
        />
    )
}

export default InputBaseWrapper
